import { render, staticRenderFns } from "./SupportArticles.vue?vue&type=template&id=537fbb58&scoped=true&"
import script from "./SupportArticles.vue?vue&type=script&lang=js&"
export * from "./SupportArticles.vue?vue&type=script&lang=js&"
import style0 from "./SupportArticles.vue?vue&type=style&index=0&id=537fbb58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fbb58",
  null
  
)

export default component.exports